module.exports = "<ngx-datatable [rows]=\"data.collection\" [headerHeight]=\"headerHeight\" class=\"material ngx-datatable\" [rowHeight]=\"'auto'\" class=\"material\"\n[columnMode]=\"'flex'\" [footerHeight]=\"40\"\n[externalPaging]=\"true\"\n[count]=\"data.page.total\"\n[offset]=\"data.page.current_page-1\"\n[limit]=\"data.page.count\"\n[messages]=\"messages\"\n(page)='data.setPage($event, params)'\n>\n\t<ng-content></ng-content>\n</ngx-datatable>"


//////////////////
// WEBPACK FOOTER
// /Users/cmedina/Code/motto_frontend/src/app/shared/table/table.component.html
// module id = ../../../../../src/app/shared/table/table.component.html
// module chunks = main